import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './locales'

// Set document lang before first paint (from saved locale)
try {
  const saved = localStorage.getItem('app_locale')
  if (saved === 'zh-CN' || saved === 'en') {
    document.documentElement.lang = saved === 'zh-CN' ? 'zh-CN' : 'en'
  }
} catch (_) {}

// Design tokens (single source of truth)
import './assets/theme.css'

// Import Toastify for notifications
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(i18n)
app.use(Vue3Toastify, {
  autoClose: 3000,
  position: 'top-right',
  theme: 'colored'
})

app.mount('#app')
